export default {
    methods: {
        storeBetIfNotLogin(betData) {
            const shouldStore = betData.numbers.length !== 0;
            if (shouldStore) {
                const formattedBetData = {
                    category_id: betData.category_id,
                    city_id: betData.currentCity.id,
                    numbers: betData.numbers.join(' - '),
                    date: betData.date,
                    city: betData.currentCity,
                    category: betData.currentGame,
                    amount_one:
                        betData.amountOne *
                        process.env.VUE_APP_CLIENT_BALANCE_UNIT,
                };
                localStorage.setItem('reBet', JSON.stringify(formattedBetData));
            }
        },
    },
};
